<template>
    <div>
        <div id="top-menu" class="d-flex justify-content-between" v-if="this.$Params.isMobile">
            <div class="logo"><img class="mw-100" :src="logoImage"></div>
            <div>
                <button class="mobile_menu" :class="{ 'open': menuOpen }" type="button" v-on:click="menuOpen = !menuOpen">
                    <div class="position-relative">
                        <span></span>
                        <span></span>
                        <span></span>
                    </div>
                </button>
            </div>
        </div>
        <header class="top-right-buttons" v-if="!this.$Params.isMobile">
            <div>
                <b-dropdown variant="bg-white">
                    <template #button-content>
                        <i class="ms-Icon ms-Icon--Settings"></i> <span style="font-size: 15px;">{{ $t('menu.gestion')
                            }}</span>
                    </template>
                    <b-dropdown-item><router-link to="/change_password"><i
                                class="ms-Icon ms-Icon--PermissionsSolid"></i> <span>{{
            $t('menu.change_password') }}</span></router-link></b-dropdown-item>
                    <b-dropdown-item><router-link to="/configuration"><i
                                class="ms-Icon ms-Icon--ConfigurationSolid"></i> <span>{{
            $t('menu.configuration') }}</span></router-link></b-dropdown-item>
                </b-dropdown>
            </div>
            <a href="logout" v-on:click.prevent="logout"><i class="ms-Icon ms-Icon--OutOfOffice"></i> <span>{{
            $t('menu.close')
        }}</span></a>
        </header>
        <aside class="sidebar" :class="{ 'open': menuOpen }">
            <div class="p-3 text-center" v-if="!this.$Params.isMobile">
                <router-link to="home"><img class="logo mw-100" :src="logoImage"></router-link>
            </div>
            <div class="menu">
                <ul class="list">
                    <li>
                        <div class="user-info">
                            <router-link to="home" class="image pl-0 waves-effect waves-block">
                                <img :src="urlAvatar" alt="User">
                            </router-link>
                            <div class="detail">
                                <small class="d-block"><strong>{{ userData.fullName }}</strong></small>
                                <small><i
                                        class="ms-Icon ms-Icon--Clock"></i><span>{{ userData.lastConnection }}</span></small>
                            </div>
                        </div>
                    </li>
                    <li v-for="(item, index) in menu" v-bind:key="index" v-wave="'ripple'">
                        <router-link @click.native="menuOpen = false" :to="item.path" active-class="active"><i
                                :class="item.meta.icon"></i><span>{{ $t('menu.' + item.name) }}</span></router-link>
                    </li>
                </ul>
            </div>
        </aside>
        <section class="content">
            <div>
                <Breadcrumb />
                <div class="container-fluid">
                    <transition name="fade-router" mode="out-in">
                        <router-view />
                    </transition>
                </div>
            </div>
            <Footer></Footer>
        </section>

        <mmModal ref="modalInfoEmail" :title="$t('atencion')" :textClose="$t('cerrar')">
            <div class="pb-5 text-center">
                {{ $t('alert_email') }}
            </div>
            <div class="form-group">
                <label>{{ $t('email') }}:</label>
                <input id="email" type="text" class="form-control" v-model="userEmail">
            </div>
            <template #buttons>
                <a href="#" @click.prevent="updateEmailUser" class="btn btn-primary">{{ $t('save') }}</a>
                <a href="#" @click.prevent="noShowEmailModal" class="btn btn-warning">{{ $t('dont_show_more') }}</a>
            </template>
        </mmModal>
        <mmModal ref="modalAuthenticator" size="md" :title="$t('validateCode')" v-if="visibleModalAuthenticator">
            <div>
                <p>{{ $t('enterCode') }}</p>
                <div class="form-group">
                    <label>{{ $t('code') }}</label>
                    <input type="text" name="codeAuthenticator" v-model="userModel.code" class="form-control" />
                </div>
            </div>
            <template #buttons>
                <a href="#" @click.prevent="updateDataUser" class="btn btn-primary">{{ $t('save') }}</a>
            </template>
        </mmModal>
    </div>
</template>

<style>
.top-right-buttons {
    position: absolute;
    top: 0;
    right: 0;
    padding-right: 5px;
    display: flex;
    gap: 15px;
    margin-right: 20px;
}

.top-right-buttons a {
    color: #000;
    /* Adjust color as needed */
    text-decoration: none;
    display: flex;
    align-items: center;
}

.top-right-buttons a i {
    margin-right: 5px;
}
</style>

<script>
import Breadcrumb from '@/views/layout/Breadcrumb.vue';
import mmModal from '@mysummar/summar-vue/src/components/mmModal.vue'
import { userService } from '@/api/user';
import Footer from '@/views/layout/Footer.vue';
import { localize } from "vee-validate";
import { langValidate } from '@/_helpers/lang/localize';
import Cookies from 'js-cookie';
import { mapActions, mapGetters } from 'vuex';

export default {
    name: 'Layout',
    data() {
        return {
            visibleModalAuthenticator: false,
            userData: [],
            userEmail: '',
            urlAvatar: '',
            menu: [],
            menuOpen: false,
            logoImage: `${this.$Params.urlImages}logo`
        }
    },
    components: {
        Footer,
        Breadcrumb,
        mmModal
    },
    computed: {
        ...mapGetters(['getUserData']),
    },
    async mounted() {
        await this.fetchUserData();
        let data = this.getUserData;

        let showInformedEmailStorage = localStorage.getItem('informed-email-pdoc');
        //si el usuario no tiene el email informado o aun no a clicado en noMostrar, mostramos Modal para actualizar su Email
        if (data.informedEmail == 0 && showInformedEmailStorage == null && this.$Params.recover == '2') {
            this.$refs.modalInfoEmail.show();
        }

        this.userData = data;
        this.urlAvatar = `${this.$Params.urlBase}img/avatar-${data.userType}.jpg`;
        this.menu = this.$router.options.routes.find(e => e.name === 'Layout').children.filter(item => item.meta.hide == undefined || !item.meta.hide);

            
            this.$i18n.locale = (this.userData.language !== '') ? this.userData.language : 'es';
            localize(this.userData.language, langValidate[this.userData.language]);
            

        //redireccio porque es obligatorio el authenticator
        let _cookieChangePassword = Cookies.get("needChangePassword");
        _cookieChangePassword === 'undefined' ? false : _cookieChangePassword;

        if (this.$Params.authenticator == '2' && data.authenticator == 0 && _cookieChangePassword) {
            this.$Params.requires_authenticator = '1';
            this.$router.push('/configuration');
        }

        this.$Params.user_authenticator = (this.$Params.authenticator != '0' && data.authenticator == 1) ? 1 : 0;
    },
    methods: {
        ...mapActions(['fetchUserData']),
        logout() {
            userService.logout();
            this.$router.push('/');
        },
        async updateEmailUser() {
            let response = await userService.userEmailInform(this.userEmail);
            if (response) {
                this.userEmail = '';
                this.$refs.modalInfoEmail.hide();
            }
        },
        noShowEmailModal() {
            this.$refs.modalInfoEmail.hide();
            localStorage.setItem('informed-email-pdoc', 1);
        }
    }
}
</script>

<style>
.fade-router-enter-active,
.fade-router-leave-active {
    transition: all .3s;
}

.fade-router-enter,
.fade-router-leave-active {
    opacity: 0;
    transform: translateY(20px);
}

.fade-router-move {
    transition: all .3s;
}

.fade-router-leave-active {
    position: absolute;
}
</style>